/**
 * Copyright 2024 Design Barn Inc.
 */

import pkg from '../package.json';

export const PACKAGE_NAME = `${pkg.name}@${pkg.version}`;
